module.exports = __webpack_public_path__ + "img/logo-black-v2.2e7c9168.svg";